import { render, staticRenderFns } from "./r-key.vue?vue&type=template&id=1455ad2a&scoped=true&"
import script from "./r-key.vue?vue&type=script&setup=true&lang=js&"
export * from "./r-key.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./r-key.vue?vue&type=style&index=0&id=1455ad2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455ad2a",
  null
  
)

export default component.exports